import PrinterIcon from "@redotech/redo-icons/printer.svg";
import { BooleanFilterOperator } from "@redotech/redo-model/views/advanced-filters/boolean-filter";
import { AdvancedFilterType } from "@redotech/redo-model/views/advanced-filters/generic-advanced-filter-data";
import { BooleanTableFilter } from "@redotech/redo-web/advanced-filters/advanced-filter";

export const PrinterFilter = (
  name: string,
  label: string,
  displayName: string,
): BooleanTableFilter => ({
  type: AdvancedFilterType.BOOLEAN,
  data: {
    name,
    type: AdvancedFilterType.BOOLEAN,
    value: null,
    operator: BooleanFilterOperator.IS,
  },
  displayName,
  label,
  boolDisplay: { falseDisplay: "unprinted", trueDisplay: "printed" },
  Icon: PrinterIcon,
});
